import { action, observable, makeAutoObservable } from 'mobx';
import api from 'src/api';
import {
    Sports,
    CompetitionPreview,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';
import { MobxValue } from 'src_common/common/mobx-utils/MobxValue';
import { SdkStaff, SportsListType } from 'src/AppState/sdk/staff';

export class LiabilitiesFiltersState {
    @observable public competitions = null;
    @observable public sportId: string | null = null;
    private sports: MobxValue<Sports | string | null>;

    public constructor(private readonly sdkStaff: SdkStaff) {
        const sportsWrapper = {
            connect: (_sports: MobxValue<Sports | string | null>): void => {
                this.fetchSports();
            },
            dispose: (): void => this.sports.setValue(null),
        };

        this.sports = MobxValue.create({
            initValue: null,
            connect: sportsWrapper,
        });
        makeAutoObservable(this);
    }

    @action public fetchSports(): void {
        this.sdkStaff
            .getAllSports()
            .then((sports) => this.fetchSportsSuccess(sports))
            .catch((err) => this.fetchSportsFailure(err));
    }

    @action public fetchSportsSuccess = (sports: SportsListType): void => {
        this.sports.setValue(sports.map(({ id, name }) => ({ id, name })));
    };

    @action public fetchSportsFailure = ({ message }: { message: string }): void => {
        this.sports.setValue(message);
    };

    public get allSports(): Sports {
        const sports = this.sports.getValue();

        if (sports === null || typeof sports === 'string') {
            return [];
        }

        return sports;
    }

    @action public closeSport = (): void => {
        this.sportId = null;
    };

    @action public editSport = ({ id }: { id: string | number; name?: string }): void => {
        this.sportId = id.toString();
    };

    // Refactor this part when websocketV2 will be ready for Liabilities
    @action public createCompetition = (data: CompetitionPreview): void => {
        // this.sdkStaff.getCompetitionsBySportId(data.sport.id);
        api.post('/competitions', data).catch(({ message }: { message: string }) => message);
    };

    @action public addCompetition = (competition: CompetitionPreview): void => {
        const active = competition.active === undefined ? false : competition.active;
        const display = competition.display === undefined ? false : competition.display;

        const decoratedCompetition = {
            ...competition,
            sport: {
                id: competition.sport.id,
                name: this.allSports.find((x) => x.id === competition.sport.id)?.name,
            },
            active,
            display,
        };

        this.createCompetition(decoratedCompetition);
    };
}
